import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      padding: theme.spacing(0, 2),
    },
    cropContainer: {
      position: 'relative',
      width: '100%',
      height: 400,
    },
    controls: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '50%',
      margin: theme.spacing(2, 0),
    },
    actions: {
      padding: theme.spacing(2),
    },
  }),
);

export default useStyles;
